<script setup lang="ts">
import type { Schemas } from "#shopware";
import { getCategoryRoute } from "@shopware/helpers";

type NavigationElement = Schemas["Category"] & {
  activeClass?: boolean;
};

const localePath = useLocalePath();
const { formatLink } = useInternationalization(localePath);
const { category } = useCategory();

const { subCategories, isCategoryFilterVisible, toggleCategoryFilter } = useSubCategoryNavigation();

</script>
<template>
  <div v-if="subCategories.length" class="my-2 mb-4">
    <nav>
      <div class="accordion-body">
        <ul
          class="flex gap-4 overflow-x-auto hide-scroll-bar scroll-smooth"
          data-menu-scroller
        >
          <li class="px-0 py-0 rounded-full">
            <span
              class="block py-1 md:py-2 text-base font-bold whitespace-nowrap"
            >
              {{ category?.translated?.name }}
            </span>
          </li>
          <template  v-for="category in subCategories">
            <li
              v-if="category.active"
              class="border border-black px-0 py-0 rounded-full"
            >
              <NuxtLink
                :to="formatLink(getCategoryRoute(category))"
                class="block px-2 py-1 md:px-4 md:py-2 whitespace-nowrap"
              >
                {{ category?.translated?.name }}
              </NuxtLink>
            </li>
          </template>
        </ul>
      </div>
      <LayoutSubCategoryScroll />
    </nav>
  </div>
</template>
<style>
.hide-scroll-bar {
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.hide-scroll-bar::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}
</style>
